import React, { useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Icon } from '@fuxi/eevee-icon';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import cx from './index.module.scss';

interface Props {
  id: number;
  item: Palpation.PointTypeWithDirection;
  handleDelTubercle: VoidFunc;
}

const DragItem: React.FC<Props> = ({ item, id, handleDelTubercle }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: id });

  const style = useMemo(
    () => ({
      transform: CSS.Transform.toString(transform),
      transition,
    }),
    [transform, transition]
  );

  return (
    <div
      className={cx('DragItem', { 'is-dragging': isDragging })}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <div className={cx('drag-item')}>
        <Icon name="close-drawer" className={cx('del-icon')} onClick={handleDelTubercle} />
        <div className={cx('content')}>
          <div className={cx('name')}>
            <div>痛点</div>
            <div className={cx('point-item-num', { right: !item.isLeft, error: item.depthWarning })}>{item.index}</div>
          </div>
          {!!item.depthWarning && (
            <div className={cx('tips')}>
              <ExclamationCircleOutlined style={{ marginRight: 4 }} className={cx('warn-icon')} />
              存在安全风险
            </div>
          )}
        </div>
        <div>
          <Icon name="move" className={cx('move-icon')} />
        </div>
      </div>
    </div>
  );
};

export default DragItem;
